import React, { FunctionComponent, useEffect, useState } from "react";

import { DashboardEditorProps, IProductTemplateTableEditor } from "components/ComponentType";
import {
  IProductTemplateDropdownChangeParams,
  ProductTemplateDropdown,
} from "components/basic/dropdowns/product-template/ProductTemplateDropdown";
import { T } from "services/lang/LanguageService";
import ProductTemplateConfig from "./ProductTemplateConfig";

export const defaultProductTemplateEditorConfig: IProductTemplateTableEditor = {
  id: undefined,
  safeName: "",
  transposed: false,
  showTitle: true,
  updateFrequency: undefined,
  hiddenColumns: [],
  onlyShownColumns: [],
  itemsPerPage: undefined,
  overrideLoadingConfig: undefined,
  filter: undefined,
  defaultFilter: undefined,
  hideDates: false,
  showFilter: false,
  allowAddEntry: true,
  allowRowEdit: true,
  showTotals: false,
};

const ProductTemplateTableEditor = ({
  config,
  onConfigChange,
}: DashboardEditorProps<IProductTemplateTableEditor>) => {
  const [currentConfig, setCurrentConfig] = useState(() => {
    if (Object.keys(config).length > 0) {
      return config;
    }
    return defaultProductTemplateEditorConfig;
  });

  useEffect(() => {
    onConfigChange(currentConfig);
  }, [currentConfig]);

  const safeNameSelectionHandler = (e: IProductTemplateDropdownChangeParams) => {
    setCurrentConfig(prevState => ({ ...prevState, safeName: e.refName, id: e.value }));
  };
  
  return (
    <div className="grid p-fluid gap-3">
      <div className="w-full flex flex-column">
        <label htmlFor="safeName">{T("word.safe-name")}</label>
        <ProductTemplateDropdown
          value={currentConfig.id}
          onChange={safeNameSelectionHandler}
        />
      </div>
      <ProductTemplateConfig currentConfig={currentConfig} setCurrentConfig={setCurrentConfig} />
    </div>
  );
};

export default ProductTemplateTableEditor as FunctionComponent;
